import ArchivePage from '../../components/archive-page';

export default ArchivePage;
